import "./approval-sla.css";

function formatHours(value) {
  if (!Number.isFinite(value)) return "–";
  const absolute = Math.abs(value);
  if (absolute < 1) return `${Math.max(1, Math.round(absolute * 60))}m`;
  if (absolute < 24) return `${Math.round(absolute * 10) / 10}h`;
  const days = Math.floor(absolute / 24);
  const hours = Math.round(absolute - days * 24);
  return hours ? `${days}d ${hours}h` : `${days}d`;
}

function milestoneLabel(sla) {
  if (sla.overdue) return `Overdue by ${formatHours(sla.remainingHours)}`;
  const reminderMatch = /^reminder(\d+)$/u.exec(String(sla.nextMilestone || ''));
  if (reminderMatch) return `${formatHours(sla.nextMilestoneHours)} to reminder ${reminderMatch[1]}`;
  return `${formatHours(sla.remainingHours)} to expiry`;
}

function urgencyClass(sla) {
  if (sla.overdue) return "overdue";
  if (sla.remainingHours <= Math.max(6, Number(sla.expiryHours || 0) * 0.2)) return "urgent";
  if (sla.reminderLevel >= 1) return "warning";
  return "normal";
}

function policyLabel(sla) {
  const schedule = Array.isArray(sla.reminderScheduleDays) ? sla.reminderScheduleDays : [];
  if (schedule.length) return `reminders day ${schedule.join('/')}, expiry day ${sla.expiryDays}`;
  return `${sla.reminderCount || 0} reminder(s), expiry day ${sla.expiryDays || '–'}`;
}

export function approvalUrgencyValue(submission) {
  const sla = submission?.sla;
  if (!sla) return Number.POSITIVE_INFINITY;
  if (sla.overdue) return Number.NEGATIVE_INFINITY;
  return Number.isFinite(sla.remainingHours) ? sla.remainingHours : Number.POSITIVE_INFINITY;
}

export function compareApprovalUrgency(a, b) {
  return approvalUrgencyValue(a) - approvalUrgencyValue(b);
}

export default function ApprovalSlaBadge({ submission, compact = false }) {
  const sla = submission?.sla;
  if (!sla) return null;
  const reminder = sla.reminderLevel > 0
    ? `Reminder ${sla.reminderLevel} of ${sla.reminderCount || sla.reminderLevel} sent`
    : "No reminder sent";

  return <div className={`approval-sla ${urgencyClass(sla)}${compact ? " compact" : ""}`}>
    <div>
      <strong>{sla.stage} SLA</strong>
      <span>{milestoneLabel(sla)}</span>
    </div>
    {!compact && <small>{reminder} · {formatHours(sla.ageHours)} in current approval stage · policy {policyLabel(sla)}</small>}
  </div>;
}
